module.exports = __webpack_public_path__ + "static/media/rectangle@2x.40eb3672.png";